import { POST_CHECK_FACILITY_SUCCESS } from '../actions/facilityActions'
export default (state = false, { type, data = false }) => {
  switch (type) {
    case POST_CHECK_FACILITY_SUCCESS:
      return data
    default:
      return state
  }
}
